import { toCloudName } from '@atlassian/jira-shared-types';
import type { Context } from '../../types';
import type { Action } from './project-access-context-action-creators';
import { SET_CONTEXT } from './project-access-context-type';

export const defaultState = {
	baseUrl: '',
	cloudName: toCloudName(''),
	isDisabled: false,
	isSiteAdmin: false,
} as const;

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (state: Context = defaultState, action: Action): Context => {
	switch (action.type) {
		case SET_CONTEXT: {
			const { baseUrl, cloudName, isDisabled, isSiteAdmin, projectId, projectType } =
				action.payload;

			const context: Context = {
				baseUrl,
				cloudName,
				isDisabled,
				isSiteAdmin,
			};

			if (projectId) {
				context.projectId = projectId;
			}

			if (projectType) {
				context.projectType = projectType;
			}

			return context;
		}

		default:
			return state;
	}
};
